import React from 'react'

import cn from 'classnames'

import FormLabel from 'components/Typography/texts/FormLabel/FormLabel'

import styles from './ToggleSwitch.module.scss'
import { ToggleSwitchProps } from './types'

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  className,
  isDisabled,
  isChecked,
  label,
  name,
  id,
  onChange,
  testId,
  ...props
}) => (
  <div className={className}>
    <FormLabel
      htmlFor={id || name}
      className={cn(styles.container, isDisabled && styles.container_disabled)}
    >
      <input
        id={id || name}
        name={name}
        type="checkbox"
        onChange={onChange}
        className={cn(styles.input, isDisabled && styles.input_disabled)}
        checked={isChecked}
        disabled={isDisabled}
        data-testid={testId}
        {...props}
      />
      <span className={cn(styles.slider, isDisabled && styles.slider_disabled)} />
      <span className={styles.label}>{label}</span>
    </FormLabel>
  </div>
)

export default ToggleSwitch
